import axios from '@/axios'

export default {
  workoutsByEvent(eventid, entrytype, category, gender, unfiltered) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-workouts/get-division-workouts/${eventid}`, {
          entrytype: entrytype,
          category: category,
          gender: gender,
          unfiltered: unfiltered
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  }
}
